import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { Header, Footer, WhatsAppFloat, ScrollToTop } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import CreationEntreprise from "@/pages/CreationEntreprise";
import Diaspora from "@/pages/Diaspora";
import Etrangers from "@/pages/Etrangers";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Suivi from "@/pages/Suivi";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Concours from "@/pages/Concours";
import ConcoursInscription from "@/pages/ConcoursInscription";
import Ambassades from "@/pages/Ambassades";
import { PolitiqueConfidentialite, ConditionsUtilisation } from "@/pages/Legal";

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/branding`)
      .then((r) => r.json())
      .then((d) => {
        if (d.favicon_url) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
          }
          link.href = `${process.env.REACT_APP_BACKEND_URL}${d.favicon_url}`;
        }
      })
      .catch(() => {});
  }, []);
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/creation-entreprise" element={<CreationEntreprise />} />
          <Route path="/diaspora" element={<Diaspora />} />
          <Route path="/etrangers" element={<Etrangers />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/suivi" element={<Suivi />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/concours" element={<Concours />} />
          <Route path="/concours/inscription" element={<ConcoursInscription />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/ambassades-consulats" element={<Ambassades />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/conditions-utilisation" element={<ConditionsUtilisation />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
      <Toaster position="top-center" richColors />
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <LanguageProvider>
          <Shell />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
